import { useCartToggleHandler, useIsInCart } from 'features/carrello/hooks';

import React from 'react';
import { ScommesseTipoBoxUiContainer } from '../../ippicaScommesseEsitoTipoBox/IppicaScommesseEsitoTipoBox';
import { selectQuotaFromEsitoMap } from 'features/ippica/selectors';
import styles from './IppicaScomesseTableRowPariDispari.module.scss';
import { useTypedSelector } from 'lib/centralStore';

export type IppicaScommesseTableRowPariDispari = {
  quote: Array<string>;
};

export const IppicaScommesseTableRowPariDispari = ({ quote }) => {
  return (
    <div className={styles.wrapper}>
      <IppicaScommesseTableColumnPariDispari label="Pari" keyQuota={quote[0]} />
      <IppicaScommesseTableColumnPariDispari label="Dispari" isReverse keyQuota={quote[1]} />
    </div>
  );
};

export type IppicaScommesseTableColumnPariDispariProps = {
  isReverse?: boolean;
  label: string;
  keyQuota: string;
};

const IppicaScommesseTableColumnPariDispari = ({
  isReverse,
  label,
  keyQuota,
}: IppicaScommesseTableColumnPariDispariProps) => {
  const quota = useTypedSelector(selectQuotaFromEsitoMap(keyQuota));
  const isActiveInCart = useIsInCart(keyQuota);
  const cartHandler = useCartToggleHandler(keyQuota);

  return (
    <div className={`${styles.container} ${isReverse ? styles.reverse : ''}`}>
      <div className={styles.label}>{label}</div>
      <ScommesseTipoBoxUiContainer
        isDisable={false}
        quota={quota}
        cartHandler={cartHandler}
        isActiveInCart={isActiveInCart}
        containerClassName={styles.quotaContainer}
        scommessaKey={keyQuota}
      />
    </div>
  );
};
